import { Component } from 'react';
import classnames from 'classnames';
import PT from 'prop-types';

import styles from './button.scss';

class Button extends Component {
  static defaultProps = {
    component: 'button',
    href: null,
    primary: false,
    skinny: false,
    bold: false,
    basic: false,
    size: 'medium',
  };

  render() {
    const {
      className,
      primary,
      skinny,
      bold,
      basic,
      href,
      component,
      size,
      children,
      ...props
    } = this.props;

    const classes = classnames(className, styles.button, styles[size], {
      [styles.primary]: primary,
      [styles.skinny]: skinny,
      [styles.bold]: bold,
      [styles.basic]: basic,
    });

    const elementProps = {};
    let Element = component;

    if (href) {
      elementProps.href = href;
      Element = 'a';
    }

    return (
      <Element {...props} {...elementProps} className={classes}>
        {children}
      </Element>
    );
  }
}

export default Button;

Button.propTypes = {
  component: PT.elementType,
  href: PT.bool,
  primary: PT.bool,
  skinny: PT.bool,
  bold: PT.bool,
  basic: PT.bool,
  size: PT.string,
};
